var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseMappingCreditsHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83333 9L2.44444 6.75H0L0.305556 5.625H2.75L3.36111 3.375H0.916667L1.22222 2.25H3.66667L4.27778 0H5.5L4.88889 2.25H7.33333L7.94444 0H9.16667L8.55556 2.25H11L10.6944 3.375H8.25L7.63889 5.625H10.0833L9.77778 6.75H7.33333L6.72222 9H5.5L6.11111 6.75H3.66667L3.05556 9H1.83333ZM3.97222 5.625H6.41667L7.02778 3.375H4.58333L3.97222 5.625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseMappingCreditsHeaderIcon);
export default __webpack_public_path__ + "static/media/course-mapping-credits-header-icon.ff80c3067f372f2fc43213e081b99b16.svg";
export { ForwardRef as ReactComponent };